import { useSearchParams } from "react-router-dom"

export const useSubmissionStatus = () => {
  const [params] = useSearchParams()
  const status = params.get("status") as "error" | "success" | undefined
  const error = params.get("error")

  const isSuccess = status === "success"
  const isError = status === "error"

  return { isSuccess, isError, error }
}
